

















































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';

import NavbarLink from './NavbarLink.vue';

@Component({
  components: { NavbarLink },
})
export default class Sidebar extends Vue {

  // TODO fix toggle sidebar and fullnavbar
  @Getter('showSidebar') showSidebar!: boolean;
  @Getter('fullNavbar') fullNavbar!: boolean;
  @Action('setShowSidebar') setShowSidebar: any;

  get pathComponentName() {
    return this.$route.name;
  }

  logoutAndClose() {
    this.$api.logout();
  }
}
